// extracted by mini-css-extract-plugin
export default {"custom-slick-slider":"Banner_custom-slick-slider__pcrhb","banner":"Banner_banner__LmhKt","bannerImage":"Banner_bannerImage__CQncn"};